import { render, staticRenderFns } from "./招投标.vue?vue&type=template&id=364d1404&scoped=true"
import script from "./招投标.vue?vue&type=script&lang=js"
export * from "./招投标.vue?vue&type=script&lang=js"
import style0 from "./招投标.vue?vue&type=style&index=0&id=364d1404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364d1404",
  null
  
)

export default component.exports